export default __webpack_public_path__ + "static/Dashboard-3@2x-ba03aeb5f09ab567940f43cd78406f95.svg";